import { defineComponent as F, useCssModule as K, inject as O, ref as m, computed as a, watch as P, onMounted as G, createElementBlock as I, openBlock as p, normalizeClass as s, unref as e, createBlock as b, createElementVNode as h, resolveDynamicComponent as $, withCtx as _, mergeProps as J, toHandlers as L, createCommentVNode as Q, renderSlot as S, createTextVNode as R, toDisplayString as U, normalizeStyle as W } from "vue";
import X from "../icon/comps/caret-down.vue.mjs";
import { modifyClassName as r } from "../../utils/buildClass.mjs";
import v from "../../utils/mapClasses.mjs";
import { unwrappedKey as Y } from "../../types/symbols.mjs";
const Z = ["id"], ee = ["id"], oe = ["aria-hidden", "id"], ne = "cdr-accordion__label", d = "cdr-accordion", ae = "cdr-accordion__icon", le = "cdr-accordion__content-container", ce = "cdr-accordion__content", ue = /* @__PURE__ */ F({
  name: "CdrAccordion",
  __name: "CdrAccordion",
  props: {
    /**
     * The unique id of an accordion.
     * @demoIgnore true
     */
    id: {
      type: String,
      required: !0
    },
    /**
     * Toggle this value to open/close the accordion.
     * @demoIgnore true
     */
    opened: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets a compact style.
     */
    compact: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets a border-aligned style.
     */
    borderAligned: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the heading level
     * @demoIgnore true
     */
    level: {
      type: [String, Number],
      required: !0
    },
    /**
     * Toggles content spacing (padding)
     */
    contentSpacing: {
      type: Boolean,
      default: !0
    },
    /**
     * Sets the readable text on CdrAccordion button (also can be slotted)
     * @demoIgnore true
     */
    label: {
      type: String
    }
  },
  emits: {
    /**
    * Emits on accordion open/close
    */
    "accordion-toggle": null
  },
  setup(n, {
    emit: B
  }) {
    const l = n, k = B, t = K(), o = O(Y, m(!1)), u = m(null), f = m(!1), i = m(l.opened ? "none" : "0px"), w = `h${l.level}`, A = a(() => o.value ? "div" : "button"), H = a(() => o.value ? "js-cdr-accordion-button" : [t["cdr-accordion__button"], "js-cdr-accordion-button"]), N = a(() => o.value ? "cdr-accordion__header--unwrapped" : "cdr-accordion__header"), z = a(() => l.compact ? r(d, "compact") : ""), E = a(() => l.borderAligned ? r(d, "border-aligned") : ""), T = a(() => f.value ? r(d, "focused") : ""), y = a(() => o.value ? r(d, "unwrap") : ""), j = a(() => l.contentSpacing ? "" : r(d, "no-spacing")), C = a(() => l.opened || o.value ? "cdr-accordion--open" : "cdr-accordion--closed"), V = (c) => {
      k("accordion-toggle", c);
    }, q = () => {
      f.value = !0;
    }, D = () => {
      f.value = !1;
    }, M = a(() => o.value ? {} : {
      click: V,
      focus: q,
      blur: D
    });
    return P(() => l.opened, (c) => {
      var g;
      i.value = c ? "0px" : `${(g = u.value) == null ? void 0 : g.clientHeight}px`, setTimeout(() => {
        var x;
        i.value = c ? `${(x = u.value) == null ? void 0 : x.clientHeight}px` : "0px", setTimeout(() => {
          i.value = c ? "none" : "0px";
        }, 350);
      }, 50);
    }), G(() => {
      l.opened && u.value && (i.value = "none");
    }), (c, g) => (p(), I("div", {
      class: s(e(o) ? null : e(v)(e(t), d, z.value, E.value, T.value, j.value)),
      id: `${n.id}-accordion`
    }, [(p(), b($(w), {
      class: s(e(t)[N.value])
    }, {
      default: _(() => [(p(), b($(A.value), J({
        class: H.value,
        id: n.id
      }, L(M.value), {
        "aria-expanded": e(o) ? null : `${n.opened}`,
        "aria-controls": e(o) ? null : `${n.id}-collapsible`
      }), {
        default: _(() => [h("span", {
          class: s(e(t)[ne]),
          id: `${n.id}-label`
        }, [S(c.$slots, "label", {}, () => [R(U(n.label), 1)])], 10, ee), e(o) ? Q("", !0) : (p(), b(X, {
          key: 0,
          class: s(e(v)(e(t), ae, C.value)),
          size: n.compact ? "small" : null
        }, null, 8, ["class", "size"]))]),
        _: 3
      }, 16, ["class", "id", "aria-expanded", "aria-controls"]))]),
      _: 3
    }, 8, ["class"])), h("div", {
      class: s(e(v)(e(t), le, C.value, y.value)),
      style: W({
        maxHeight: e(o) ? "none" : i.value
      })
    }, [h("div", {
      class: s(e(v)(e(t), ce, C.value, y.value)),
      "aria-hidden": e(o) ? void 0 : `${!n.opened}`,
      id: `${n.id}-collapsible`,
      ref_key: "accordionContentEl",
      ref: u
    }, [S(c.$slots, "default")], 10, oe)], 6)], 10, Z));
  }
});
export {
  ue as default
};
